// extracted by mini-css-extract-plugin
module.exports = {"component_app_item":"index-module_component_app_item_151yw","small_item":"index-module_small_item_sbfJw"};